import { render, staticRenderFns } from "./ModalClients.vue?vue&type=template&id=0454b730&"
import script from "./ModalClients.vue?vue&type=script&lang=js&"
export * from "./ModalClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports